<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("headers.patrolRouteAdd") }}</h3>
            </div>
            <div class="card-body">
                <div class="p-4">
                    <PatrolRouteFrom ref="patrolRouteForm" @submit="addPatrolRoute" />
                </div>
            </div>
        </div>

        <div class="my-4">
            <button class="btn btn-primary w-100 py-3 fw-bold fs-5 text-white" @click="submitForm">{{ $t("utils.save") }}</button>
        </div>
    </div>
</template>

<script>
import PatrolRouteFrom from '@/components/dashboard/PatrolRouteFrom.vue';

export default {
    components: {
        PatrolRouteFrom,
    },
    methods: {
        submitForm() {
            if (this.$refs.patrolRouteForm?.submitForm) {
                this.$refs.patrolRouteForm.submitForm();
            }
        },
        addPatrolRoute(data) {
            const formData = {
                name: data.name,
                frequency_minutes: data.frequency,
                started_at: data.startedAt,
                finished_at: data.finishedAt,
            }

            this.$store.getters.api.post(`/dashboard/${this.$route.params.slug}/patrols/add`, formData)
            .then(response => {
                this.$router.push({
                    name: "PatrolRouteDetailView",
                    params: {
                        slug: this.$route.params.slug,
                        id: response.data.id,
                    }
                });
            })
            .catch(error => {
                console.error("Error adding patrol route.", error);
            });
        }
    }
}
</script>